import Button from "@mui/material/Button";
import type { ButtonProps } from "@mui/material/Button";
import { useTranslation } from "react-i18next";


type Props = {
    href?: string;
    labelKey?: string;
} & Omit<ButtonProps<"a">, "href" | "component" | "ref">;

export default function DownloadPdfButton({
    href,
    labelKey = "buttons.downloadPdf",
    ...rest
}: Props) {
    const { t } = useTranslation("urlStatusBanner");

    return (
        <Button
            {...rest}
            component="a"
            href={href ?? ""}
            download
            disabled={!href}
        >
            {t(labelKey)}
        </Button>
    );
}
